import React, { useRef } from "react";
import {
  getPossibleValuesByStepProperty,
  PersonalizationValue,
  TriggerStepCreate,
} from "@dots-projects/types";
import { Controller, useForm } from "react-hook-form";
import { Select } from "antd";
import produce from "immer";
import { saveDraft, updateStep } from "./reducer/actionCreators";
import { useTriggerEditorStateDispatch } from "./TriggerEditor";
import invariant from "ts-invariant";
import { StepFormWithCommonParts } from "./TriggerStepForm";
import { FormLabel } from "./FormLabel";
import { TriggerEditorVariablesSelector } from "./TriggerEditorVariablesSelector";
const { Option } = Select;

/**
 */
export function StepFormFindUser({
  step,
  insertVariables,
}: {
  step: TriggerStepCreate;
  insertVariables: PersonalizationValue[];
}) {
  invariant(step.type === "find_user");

  const { state } = useTriggerEditorStateDispatch();
  const readOnly = !state.trigger.current.isDraft;

  const defaultValues = {
    field: step.configs.field,
    value: step.configs.value,
    name: step.name,
  };

  const form = useForm({
    defaultValues,
  });
  const { handleSubmit, control } = form;
  const { dispatch, onPersist } = useTriggerEditorStateDispatch();

  const userFields = getPossibleValuesByStepProperty("find_user", "field");

  const defaultEventTypeValue = userFields.find((userField) => {
    return userField.value === defaultValues.field;
  });

  const onSubmit = async (data: any) => {
    // This uses the immer library to create a new copy of step (with updates)
    // without affecting the original step.
    const newStep = produce(step, (stepDraft) => {
      stepDraft.configs.field = data.field;
      stepDraft.configs.value = data.value
        ? `{{${data.value.replaceAll(/{|}/g, "")}}}`
        : "";
      stepDraft.name = data.name;
    });
    dispatch(updateStep(newStep));
    dispatch(saveDraft(onPersist));
  };

  return (
    <StepFormWithCommonParts
      onSubmit={handleSubmit(onSubmit)}
      customTitle={"Find a user by field"}
      form={form}
      step={step}
    >
      <FormLabel label="What field is this?" />
      <Controller
        control={control}
        name="field"
        render={({ field }) => (
          <>
            <Select
              disabled={readOnly}
              showSearch
              placeholder={"Select field type"}
              onChange={field.onChange}
              defaultValue={defaultEventTypeValue?.label || null}
            >
              <Option key={-1} value={-1} name="" disabled>
                {"Select field type"}
              </Option>
              {userFields.map((field, index) => {
                return (
                  <Option
                    key={field.value}
                    value={field.value}
                    name={field.label}
                    id={index}
                  >
                    {field.label}
                  </Option>
                );
              })}
            </Select>
          </>
        )}
      />

      <FormLabel label="Pick which response has the field value" />
      <TriggerEditorVariablesSelector
        triggerVariables={insertVariables}
        defaultValue={defaultValues.value}
        control={control}
        readOnly={readOnly}
        fieldName={"value"}
        placeholder={"Pick which response has the field value"}
      />
    </StepFormWithCommonParts>
  );
}
